import * as API from "../api"

export type LoggerLevel = "WARN" | "ERROR"
export interface LoggerOptions {
    sourceId: string
    message: string
    level: LoggerLevel
}

export const sendLogToServer = (options: LoggerOptions): Promise<any> => {
    return API.loggers(Object.assign(options, {
        sourceId: "SL UI: " + options.sourceId
    }))
}
